import { render } from "./phone-bar.vue?vue&type=template&id=107e5d84&scoped=true"
import script from "./phone-bar.vue?vue&type=script&lang=js"
export * from "./phone-bar.vue?vue&type=script&lang=js"

import "./phone-bar.vue?vue&type=style&index=0&id=107e5d84&scoped=true&lang=scss"

import exportComponent from "E:\\my-work\\company\\product\\LessonPlay\\inner-training\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-107e5d84"]])

export default __exports__